import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import banner from "assets/images/heylime-layout/banner.png";
import { ReactComponent as LogoSvg } from "assets/images/heylime-layout/logo.svg";
import useWindowSize from "components/shared/WindowResize";
import { set_sign_in_details } from "redux/signin/action";

const HeyLimeLayout = ({ children }) => {
  const { width } = useWindowSize();
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    signinReducer: { sign_in_details: { sign_up, sign_up_with_email } = {} }
  } = useSelector((state) => state);

  const password_reset = history.location.pathname === "/password_reset";

  const handleFooterClick = () => {
    if (sign_up_with_email && !password_reset)
      dispatch(set_sign_in_details({ sign_up, sign_up_with_email: false }));
    else history.push("/");
  };

  return (
    <div className="heylime-main">
      <div className="heylime-container">
        <div className="first-section">
          <img alt="" src={banner} />
        </div>
        <div className={`second-section ${width > 1800 ? "all-padding" : ""}`}>
          <div className="middle-form">
            <div className="logo">
              <LogoSvg
                className="logo-icon"
                onClick={() => history.push("/")}
              />
            </div>
            {children}
          </div>
          <div className="footer">
            <h2 className="footer-text">
              © 2024 heyLIME. All rights reserved.
            </h2>
            <h2 className="footer-text home" onClick={handleFooterClick}>
              {sign_up_with_email && !password_reset
                ? sign_up
                  ? "Back to Social Sign Up"
                  : "Back to Social Log In"
                : "Back to Home"}
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeyLimeLayout;
